/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "0bf2f7e151e7c6b7af88a37fda5a89f95a05cf51";
